import ContactCard from "../components/ContactCard";
import ContactForm from "../components/ContactForm";
import CallToAction from "../components/CallToAction";

function Contact() {
	return (
		<section id="contact" className="desktopMaxWidth contactSection">
			<div className="contactHeroContainer">
				<p className="sectionHeroTitle">Contact</p>
				<p className="sectionHeroText">Home / Contact</p>
			</div>
			<div className="contactContainer">
				<ContactCard />
				<ContactForm />
			</div>

			<CallToAction />
		</section>
	);
}

export default Contact;
